import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function join_email_list({name='', email='', source='', message='', organization=''}) {
    /**
     * This function adds a user to the email list, along with additional information.
     * 
     * @param {string} name - The name of the user.
     * @param {string} email - The email of the user.
     * @param {string} source - The source of the user.
     * @param {string} message - The message of the user.
     * @param {string} organization - The organization of the user.
     */
    const requestJson = {
        "name": name,
        "email": email,
        "source": source,
        "message": message,
        "organization": organization
    }
    // '/join_email_list' was the Flask-era path; replaced by '/subscribe' in
    // the December migration (same payload shape).
    const retJson = await generic_backend_request_post(requestJson, '/subscribe');
    return retJson;

}

export default join_email_list